import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "@rubbl-core";

@Component({
  selector: "app-signup",
  templateUrl: "./signup.component.html",
  styleUrls: ["./signup.component.scss"],
})
export class SignupComponent implements OnInit {
  constructor(private authenticationService: AuthenticationService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    const capability = this.route.snapshot.queryParams.capability;
    const capabilityMappings = {
      renter: "/renter/dashboard",
      owner: "/owner/dashboard",
    };

    let redirecturl;

    if (capability in capabilityMappings) {
      redirecturl = capabilityMappings[capability];
    }

    this.authenticationService.signUp(redirecturl);
  }
}
